import React from "react";
import Langs from "../../app/lang/langs";
import ConfirmDialog from "./ConfirmDialog";

/**
 * A yes/no question, drawn by the shared ConfirmDialog.
 * @param {Function} [props.onDeny] - the "no" button is itself an action (e.g. discard);
 *        closing the dialog still only calls onHide
 */
export function ConfirmModal(props) {
    return (
        <ConfirmDialog
            open={!!props.show}
            title={props.title}
            message={props.message}
            confirmLabel={props.confirmTitle || <Langs str="YES" />}
            cancelLabel={props.onDeny ? (props.denyTitle || <Langs str="CANCEL" />) : <Langs str="NO" />}
            onConfirm={props.onConfirm}
            onCancel={props.onDeny || props.onHide}
            onClose={props.onHide}
        />
    )
}
